import React, { useState, useEffect, useRef } from "react";
import style from "./ApplicantDetails.module.scss";
import ShortListRejectButton from "../../components/UI/ShortlistRejectButton/ShortListRejectButton";
import ShortlistPopup from "../../components/ShortlistPopup/ShortlistPopup";
import { useParams } from "react-router-dom";
import toast from "../../components/Toast/toast";
import { updateUserStatus } from "../../service/service";
import { format } from "date-fns";
import { API } from "../../service/Interceptor";
import DownloadIconSVG from "../../components/SVGComponents/DownloadIconSVG";
// import FollowersList from "../../components/Followers/FollowersList/FollowersList";
import UserResume from "../../components/UserResume/UserResume";
import PDFPreview from "components/common/PDFPreview/PDFPreview";
import Button from "components/UI/Button/Button";
import { downloadPdf, getProfileHtmlTemplate } from "utils/pdfTemplateUtil";
import SpinnerLoader from "components/UI/SpinnerLoader/SpinnerLoader";
import ApplicantDetailsSkeleton from "./ApplicantDetailsSkeleton";
import { serverFiles } from "utils/utils";
import NoImageSVG from "components/SVGComponents/NoImageSVG";
import { RxHeight } from "react-icons/rx";

const ApplicantDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState("none");
  const { projectId, applicantId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadProfile = () => {
    const onError = () => {
      setIsLoading(false);
    };

    const onSuccess = () => {
      setIsLoading(false);
    };
    setIsLoading(true);
    downloadPdf(getProfileHtmlTemplate(data, userData), onSuccess, onError, {
      filename: `${data?.firstName || ""} ${data?.lastName || ""}.pdf`,
      isImages: true,
    });
  };

  // get userId first before calling the API.
  const handleShortListModalYes = async () => {
    //API call to shortlist the candidate.
    try {
      //
      await updateUserStatus("SHORTLIST", projectId, data?.userId);
      toast.success("Candidate shortlisted!");
      // setIsModalOpen("none");
      window.location.reload();
    } catch (error) {
      toast.error("Failed to shortlist candidate.");
    } finally {
      setIsModalOpen("none");
    }
  };

  const handleRejectModalYes = async () => {
    //API call to reject the candidate.
    try {
      await updateUserStatus("REJECTED", projectId, data?.userId);
      toast.success("Candidate rejected.");
      window.location.reload();
    } catch (error) {
      toast.error("Failed to reject candidate.");
    } finally {
      setIsModalOpen("none");
    }
  };

  const handleModalNo = async () => {
    //Close by clicking cancel button of Modal
    setIsModalOpen("none");
  };

  const shortListCandidate = () => {
    setIsModalOpen("shortList");
  };

  const rejectCandidate = () => {
    setIsModalOpen("reject");
  };

  //User data to pass it to the reusable userResume as backend response might differ.
  const userData = {
    mobileNo: data?.mobileNo || "N/A",
    gender: data?.gender || "N/A",
    state: {
      name: data?.state?.name || "N/A",
    },
    city: {
      name: data?.city?.name || "N/A",
    },
    educations: data?.educations || [],
    workExperiences: data?.workExperiences || [],
    skills: data?.skills || [],
    otherActivities: data?.otherActivities || [],
    industry: data?.industry || [],
    categories: data?.categories || [],
  };

  //applicantID is the applicationNumber.
  useEffect(() => {
    // console.log(1);
    const fetchUserDetails = async () => {
      setLoading(true);
      try {
        const res = await API.get(`api/jobs/${applicantId}/user-details`);
        setData(res?.data?.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserDetails();
  }, []);

  return (
    <section className={style.applicantDetail}>
      <section className={style.pageSection}>
        {loading && <ApplicantDetailsSkeleton />}

        {!loading && (
          <>
            <div className={style.profileContainer}>
              <div className={style.profile}>
                {data?.profileUrl ? (
                  <img src={serverFiles(data?.profileUrl)} alt="profilepic" />
                ) : (
                  <NoImageSVG
                    style={{
                      height: "5rem",
                      width: "5rem",
                    }}
                    type="profile"
                  />
                )}
                {/* <img src={"http://173.249.24.68:9610/api/files/profile/1d086661-59c3-4d30-a33e-8c2952eff667_madhuri.jpg"} /> */}
                <div className={style.profileText}>
                  <p>
                    {data?.firstName} {data?.lastName}
                  </p>
                  <p>{data?.email}</p>

                  {data?.applicationStatus !== "SHORTLIST" &&
                    data?.applicationStatus !== "REJECTED" && (
                      <p>
                        Applied On{" "}
                        {data?.createdAt
                          ? format(new Date(data?.createdAt), "d MMMM yyyy")
                          : "-"}
                      </p>
                    )}

                  {data?.applicationStatus === "SHORTLIST" && (
                    <p className={style.shortlistDate}>
                      Shortlisted On{" "}
                      {data?.applicationStatusDate
                        ? format(
                          new Date(data?.applicationStatusDate),
                          "d MMMM yyyy"
                        )
                        : "-"}
                    </p>
                  )}

                  {data?.applicationStatus === "REJECTED" && (
                    <p className={style.rejectDate}>
                      Rejected On{" "}
                      {data?.applicationStatusDate
                        ? format(
                          new Date(data?.applicationStatusDate),
                          "d MMMM yyyy"
                        )
                        : "-"}
                    </p>
                  )}
                </div>
              </div>
              <div className={style.profileActionWrapper}>
                <Button
                  className={style.downloadProfile}
                  leftIcon={
                    isLoading ? (
                      <SpinnerLoader
                        containerClassName={style.loaderContainer}
                        loaderClassName={style.loader}
                      />
                    ) : (
                      <DownloadIconSVG />
                    )
                  }
                  disabled={isLoading}
                  onClick={handleDownloadProfile}
                >
                  Download
                </Button>
                {/* <ShortListRejectButton /> */}
                <ShortListRejectButton
                  status={data?.applicationStatus}
                  shortList={shortListCandidate}
                  Reject={rejectCandidate}
                  userId={applicantId}
                />
              </div>
            </div>
            <hr />

            <div className={style.personalDetails}>
              {/* <p>Personal Details</p> */}
              <div className={style.contentholder}>
                {/* <div className={style.dataItem}>
                  <p>Mobile Number</p>
                  <p>{data?.mobileNo}</p>
                </div>
                <hr /> */}

                <UserResume data={userData} />

                {data?.portfolioUrl && (
                  <div className={style.portfolioSection}>
                    <p
                      style={{
                        marginBottom: "1rem",
                      }}
                    >
                      Portfolio
                    </p>
                    <PDFPreview url={serverFiles(data?.portfolioUrl)} />
                    <div className={style.downloadBtnSection}>
                      {/* <p>Max. files size : 10MB</p> */}
                      <a
                        href={serverFiles(data?.portfolioUrl)}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button>
                          <DownloadIconSVG />
                          <p>Download</p>
                        </button>
                      </a>
                    </div>
                  </div>
                )}

                {data?.additionalLink?.length && (
                  <div className={style.additionalLinks}>
                    <p className={style.additionalLinks_heading}>
                      Additional URLs
                    </p>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className={style.additionalLinks_URL}
                      href={data?.additionalLink[0]}
                    >
                      {data?.additionalLink[0]}
                    </a>
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </section>

      <ShortlistPopup
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        handleModalNo={handleModalNo}
        handleShortListModalYes={handleShortListModalYes}
        handleRejectModalYes={handleRejectModalYes}
      />
    </section>
  );
};

export default ApplicantDetails;
